import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store"
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

 function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}


const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);
function GetAccidentsByStage(stage, mydata, uid) {
  const data = {
    stage,
    myData: mydata,
    User: uid
  };
  return client.post("Accidents/GetAccidentsByStage", prepareRequest(data));
}

function GetPastAccidentsByRegNumber(regnumber) {
  const data = {
    regnumber,
  };
  return client.post("Accidents/GetPastAccidentsByRegNumber", prepareRequest(data));
}

function GetAccident(id) {
  const data = { Id: id };
  return client.post("Accidents/GetAccident", prepareRequest(data));
}

function GetCallCenterAllAccidents(item) {
  if (item.searchText === "") {
    item.searchText = null;
  }
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    NewClaim: item.newClaim,
    MyData: item.myData,
    Uid: item.uid,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize,
    DataExport: item.dataExport
  };
  return client.post("Accidents/GetCallCenterAllAccidents", prepareRequest(data));
}

function UpdateAccident(item) {
  return client.post("Accidents/UpdateAccident", prepareDataRequest(item));
}

function CreateAccident(item) {
  return client.post("Accidents/CreateAccident", prepareDataRequest(item));
}

function DeleteAccident(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("Accidents/DeleteAccident", prepareDataRequest(item));
}

function SendToComm(id, uid) {
  var item = { Id: id, commandUserId: uid };
  return client.post("Accidents/SendToComm", prepareRequest(item));
}

function GetAccidentsByStatus(id, claimid, statusid, uid) {
  var item = { id: id, claimid: claimid, statusid: statusid, commandUserId: uid }
  return client.post("Accidents/GetAccidentsByStatus", prepareRequest(item));
}

function GetCommApprovals(item) {
  if (item.searchText === "") {
    item.searchText = null;
  }
const data = {
  DtFrom: item.startDate,
  DtTo: item.endDate,
  StatusType: item.statusType,
  SearchType: item.searchType,
  SearchText: item.searchText,
  PageNumber: item.pageNumber,
  PageSize: item.pageSize
};

  return client.post("Accidents/GetCommApprovals", prepareRequest(data));
}

function SendNewAccidentToComm(item) {
  return client.post("Notifications/NewAccidentToComm", item);
}



// Accident END

// Accident Comm START
function GetCommData(id) {
    const data = { Id : id };
   return client.post("CommData/GetCommDataByAccident", prepareRequest(data));
}

function CreateCommData(id, uid) {
  let item = { accidentId: id, commandUserId: uid };
  return client.post("CommData/CreateComm", prepareDataRequest(item));
}

function UpdateCommData(item) {
  return client.post("CommData/UpdateComm", prepareDataRequest(item));
}

function SendToClientService(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("CommData/SendToClientService", prepareRequest(item));
}

function CommDateUpdateByType(id, type, uid) {
  var item = { id: id, type: type, commandUserId: uid };
  return client.post("CommData/CommDateUpdateByType", prepareRequest(item));
}

function SendToCommApproval(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("CommData/SendToCommApproval", prepareRequest(item));
}

function CommUserUpdate(id, respUid, uid) {
  var item = { id: id, respUid: respUid, commandUserId: uid }
  return client.post("Accidents/CommUserUpdate", prepareRequest(item));
}

function GetCommSchedule(type) {
  return client.get("CommData/GetCommSchedule/" + type);
}

function AccidentCommStart(id, uid) {
  var item = { Id: id, commandUserId: uid };
  return client.post("Accidents/AccidentCommStart", prepareRequest(item));
}

function AccidentWrongCallInsert(id, uid) {
  var item = { Id: id, commandUserId: uid };
  return client.post("Accidents/AccidentWrongCallInsert", prepareRequest(item));
}


// Accident Comm END

// Participant START
function GetParticipants(id) {
  const data = { AccidentId: id };
  return client.post("Participants/GetAccidentParticipants", prepareRequest(data));
}

function GetParticipant(id) {
  const data = { Id: id };
  return client.post("Participants/GetParticipant", prepareRequest(data));
}

function GetVictimParticipant(id) {
  const data = { Id: id };
  return client.post("Participants/GetVictimParticipant", prepareRequest(data));
}

function CreateParticipant(item) {
  return client.post("Participants/CreateParticipant", prepareDataRequest(item));
}

function UpdateParticipant(item) {
  return client.post("Participants/UpdateParticipant", prepareDataRequest(item));
}

function DeleteParticipant(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("Participants/DeleteParticipant", prepareDataRequest(item));
}

function CopyParticipant(id, accidentId, uid) {
  var item = { id: id, accidentId: accidentId, commandUserId: uid };
  return client.put("Participants/CopyParticipant", item);
}

function CheckPolicyStatus(accidentId) {
  const data = { AccidentId: accidentId };
  return client.post("Participants/CheckPolicyStatus", prepareRequest(data));
}



// Participant END

//Client Service Start

function ClientServiceUserUpdate(id, respUid, uid) {
  var item = { Id: id, RespUid: respUid, CommandUserId: uid }
  return client.post("Accidents/ClientServiceUserUpdate",  prepareRequest(item));
}

function ClientServiceStart(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("Accidents/ClientServiceStart",  prepareRequest(item));
}



export {
  GetAccidentsByStage,
  CreateAccident,
  UpdateAccident,
  DeleteAccident,
  GetAccident,
  SendToComm,
  CreateCommData,
  UpdateCommData,
  GetCommData,
  GetParticipants,
  UpdateParticipant,
  CreateParticipant,
  GetParticipant,
  DeleteParticipant,
  SendToClientService,
  ClientServiceUserUpdate,
  ClientServiceStart,
  GetAccidentsByStatus,
  GetCallCenterAllAccidents,
  GetVictimParticipant,
  CommDateUpdateByType,
  SendToCommApproval,
  GetCommApprovals,
  CommUserUpdate,
  GetCommSchedule,
  AccidentCommStart,
  SendNewAccidentToComm,
  CopyParticipant,
  CheckPolicyStatus,
  AccidentWrongCallInsert,
  GetPastAccidentsByRegNumber,
};
